export default class Footer extends window.HTMLElement {
    constructor () {
		super();
    }

	styling() {
		return `
			<style>
				.footer-wrapper {
					border-top: 1px solid #ccc;
					font-size: 1em;
					position: fixed;
					bottom: 0;
					background: #fff;
					width: 100%;
					z-index: 41;
				}
				.sticky-footer {
					z-index: 41;
					display: flex;
					align-items: center;
					justify-content: ${this.dataset.flexjustify};
					padding-top: 1em !important;
					padding-bottom: 1em !important;
				}

				.footer-extra-info {
					font-size: .9em;
				}

				.sticky-footer > button,
				.sticky-footer > .button {
					margin: 0 .5em 0 !important;
					min-width: 10em;
				}

				button:focus,
				.button:focus {
					box-shadow: 0 0 0 2px #ffffff, 0 0 3px 5px #3a97f9;
				}

				@media only screen and (max-width: 600px) {
					div.sticky-footer {
						flex-wrap: wrap;
						justify-content: space-between;
						padding-top: 1em !important;
						padding-bottom: 1em !important;
					}

					.sticky-footer > * {
						margin: 0;
					}

					.sticky-footer > button,
					.sticky-footer > .button {
						min-width: auto;
						flex: 1 1 auto !important;
						margin-bottom: 0 !important;
					}

					.sticky-footer > button:first-of-type,
					.sticky-footer > .button:first-of-type {
						margin-right: 1em;
					}

					span.footer-extra-info {
						flex: 1 1 100%;
						text-align: center;
						margin-bottom: 1em;
					}
				}

			</style>
		`.trim();
	}

    connectedCallback ()  {
		this.innerHTML += this.styling();
	
		this.message = this.dataset.message || '';
		this.secondaryButtonHtml = this.dataset.secondary || '';
		this.primaryButtonHtml = this.dataset.primary || '';
		this.bottomPadding = this.dataset.bottomPadding || 0;

		const stickyFooter = document.createElement('div');
		stickyFooter.setAttribute("class", "footer-wrapper");

		stickyFooter.innerHTML += `
			<div class="sticky-footer width-constraint">
				${ this.message.length ? `<span class="footer-extra-info">${this.message}</span>` : ``}
				${this.secondaryButtonHtml}
				${this.primaryButtonHtml}
			</div>`;

		const bottomPadding = Number(this.bottomPadding);
		document.body.style.paddingBottom = `${bottomPadding}em`;
        document.body.appendChild(stickyFooter);
    }
}



// WEBPACK FOOTER //
// ./src/js/components/footer.js